
import { Suspense, lazy, useEffect } from "react";
import { Routes, Route} from "react-router-dom";
import Home from "../pages/HomePage";
import BrowseRooms from "../pages/BrowseRooms";
import ServicesPage from "../pages/ServicesPage";
import BlogPage from "../pages/BlogPage";
import ContactPage from "../pages/ContactPage";
import TermsofUses from "../pages/TermsofUses";
import FaqPage from "../pages/FaqPage";
import Partnership from "../pages/Partnership";
import PlaceDetailsPage from "../pages/PlaceDetails";
import DataRightsPage from "../pages/DataRightsPage";
const AboutUsPage = lazy(() => import("../pages/AboutUsPage"))

const ExternalRedirect = ({ to }) => {
    useEffect(() => {
        window.location.href = to;
    }, [to]);
    return null;
};

const PageRoutes = () => {


    return (
        <>
  <Suspense fallback={<div>Loading...</div>}>
 
  
    <Routes>
     
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUsPage/>} />
        <Route path="/services" element={<ServicesPage/>}/>
        <Route path="/blog" element={<BlogPage/>}/>
        <Route path="/contact" element={<ContactPage/>}/>
        <Route path="/terms-of-use" element={<TermsofUses/>}/>
        <Route path="/faq" element= {<FaqPage/>}/>
        <Route path="/data-rights" element={<DataRightsPage/>}/>
        <Route path="/browse-rooms" element= {<BrowseRooms/>}/>  
        <Route path="/partnership" element={<Partnership/>}/>
        <Route path="/place/:id" element={<PlaceDetailsPage/>}/>
        <Route path="/varkala" element={<ExternalRedirect to="https://www.zotel.ai/website/1710" />}/>

        {/* <Route path =".features" element={<Features/>}/>
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/review" elemnt={<Review/>}/>
        <Route path="/contact" element={<Contact/>} /> */}
      
      </Routes>
   
  </Suspense>
        </>
    )
}
export default PageRoutes;